<div class="desktop-model-year-vin-selection" [hidden]="windowWidth<=1024">
    <form [hidden]="hideSelectionSection" [formGroup]="searchForm" novalidate name="searchForm" class="m-0">
        <div class="vehicle-search-form d-flex float-right" style="position:absolute;top:5px;" [ngClass]="{'mb-1':appName === 'lexus','mb-0':appName === 'toyota'}">
            <div>
                <div class="p-0 suggestion-block">
                    <div class="suggestion-message" style="margin-top: 10px;">
                        <span [hidden]="appName === 'toyota'"> SELECT YOUR VEHICLE TO BEGIN</span>
                        <span [hidden]="appName === 'lexus'"> Select your vehicle to begin</span>
                    </div>

                </div>
            </div>

            <div class="ml-3 suggestion-block" style="visibility: hidden;">
                <div class="p-0">
                    <div class="suggestion-message">
                        <span> Select your vehicle to begin</span>
                    </div>
                </div>
            </div>

            <!-- Hiding VIN Search for Production Deployment -->
            <div class="or-block ml-3" style="visibility: hidden;">
                OR
            </div>

            <div class="vin-search ml-3 suggestion-block" style="margin-top: 5px;">
                <div class="p-0" *ngIf="!showError && searchForm.get('vin').errors">
                    <div class="error-message text-center hightlight-text" *ngIf="!searchForm.get('vin').errors?.required && searchForm.get('vin').errors?.pattern">
                        <span>{{"Message.invalid_VIN" | translate}}</span>
                    </div>
                    <div class="error-message text-center hightlight-text" *ngIf="isSubmitted && searchForm.controls['vin'].value !=='' && !searchForm.get('vin').errors?.pattern && searchForm.controls['vin'].errors.minlength">
                        <span> {{"Message.maxlength_VIN" | translate}}</span>
                    </div>
                </div>
                <div class="suggestion-message">
                    <div class="error-message text-center hightlight-text" *ngIf="isSubmitted && !searchForm.get('vin').errors && vinError">
                        <span>{{"Message.VIN_NOT_EXITSTS" | translate}}</span>
                    </div>
                </div>
                <div class="suggestion-message">
                    <div class="error-message text-center hightlight-text" *ngIf="isSubmitted && !searchForm.get('vin').errors && vinNotAvalibaleError">
                        <span> {{"Message.VIN_NOT_AVAILABLE" | translate}}</span>
                    </div>
                </div>
                <div class="suggestion-message">
                    <div class="error-message text-center hightlight-text" *ngIf="isSubmitted && !searchForm.get('vin').errors && vinYearNotAvalibaleError && appName === 'toyota'">
                        <span> {{"Message.VIN_TOYOTA_YEAR_NOT_AVL_ERROR" | translate}}</span>
                    </div>
                </div>
                <div class="suggestion-message">
                    <div class="error-message text-center hightlight-text" *ngIf="isSubmitted && !searchForm.get('vin').errors && vinYearNotAvalibaleError && appName === 'lexus'">
                        <span> {{"Message.VIN_LEXUS_YEAR_NOT_AVL_ERROR" | translate}}</span>
                    </div>
                </div>
                <div *ngIf="this.resultLinkSet" class="suggestion-message">
                    <div class="error-message text-center hightlight-text" *ngIf="isSubmitted && !searchForm.get('vin').errors && vinInOtherDivisionError">

                        <span *ngIf="appName === 'lexus'" style="color:#505050;display:inline-block;">
                            Sorry, This is a Toyota VIN.
                            <a target="_self" [href]="this.resultLink" style="color: #B6A171">
                                Click Here</a> to visit the Toyota site.
                        </span>

                        <span *ngIf="appName !== 'lexus'" style="color:#505050;display:inline-block;">
                            Sorry, This is a Lexus VIN.
                            <a target="_self" [href]="this.resultLink" style="color: #C00">
                                Click Here</a> to visit the Lexus site.
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Error message block -->
        <div class="vehicle-search-form form-group d-flex float-right" [ngClass]="{'mb-1':appName === 'lexus','mb-0':appName === 'toyota'}"
            style="margin-top:30px;">
            <div *ngIf="appName === 'toyota'">
                <select class="header-dropdown model-name" formControlName="model" name="model" (change)="onModelChange($event)">
                    <option class="heading" value="" disabled="" hidden="">SELECT MODEL</option>
                    <option *ngFor="let models of vehicleModel" value="{{models.model}}" [ngClass]="{'capitalize':appName === 'toyota'}">
                        {{models.model}}
                    </option>
                </select>
            </div>
            <div *ngIf="appName === 'lexus'">
                <select class="header-dropdown model-name lexus-dropdown" formControlName="model" name="model" [ngClass]="{'is-invalid-selection': (isSubmitted && showError && searchForm.get('model').errors?.required)}"
                    (change)="onModelChange($event)" required>
                    <option value="">{{ "Label.select_internal_model" | translate}}</option>
                    <option *ngFor="let models of vehicleModel" value="{{models.model}}">
                        {{models.model}}
                    </option>
                </select>
            </div>

            <div class="ml-3">

                <select [attr.disabled]="searchForm.controls['model'].value ===''?true:null" formControlName="year" name="year" class="header-dropdown"
                    [ngClass]="{'lexus-dropdown':appName === 'lexus','is-invalid-selection': (isSubmitted && showError && !searchForm.get('model').errors?.required && searchForm.get('year').errors?.required)}"
                    (change)="onYearChange($event)">
                    <option value="">SELECT YEAR</option>
                    <ng-container>
                        <option *ngFor="let years of vehicleYear" value="{{years}}">
                            {{years}}
                        </option>
                    </ng-container>
                </select>
            </div>

            <!-- Hiding VIN Search for Production Deployment -->

            <div class="or-block ml-3">
                OR
            </div>

            <div class="vin-search ml-3" [ngClass]="{'invalid-vin': ((searchForm.controls['vin'].value !=='') && (vinError || vinNotAvalibaleError ||vinYearNotAvalibaleError || vinInOtherDivisionError))}">
                <mat-form-field appearance="outline" class="container-auto">
                    <input (input)="onVinKeyup($event.target.value)" matInput minLength="17" maxLength="17" class="vin-textbox" placeholder="ENTER 17 DIGIT VIN"
                        matTooltip="Add your VIN to access your vehicle specific support information." matTooltipPosition="above"
                        [disabled]="searchForm.controls['model'].value !=='' && searchForm.controls['year'].value !== ''" [ngClass]="{'invalid-vin': ( vinError || vinNotAvalibaleError ||vinYearNotAvalibaleError || vinInOtherDivisionError)}"
                        formControlName="vin" type="text" aria-live="off" [matTooltipClass]="getTooltipContent()">
                    
                </mat-form-field>
            </div>

            <div class="ml-3">
                <button type="button" *ngIf="!isSearchButtonSubmitted" [disabled]="commonService.disableSupportTopicPage(searchForm)" name="get-started"
                    (click)="onSearch();" class="btn getstarted-btn">{{ "Button.get_started" | translate}}
                </button>
                <button type="button" *ngIf="isSearchButtonSubmitted" [disabled]="disableSearchButton" name="get-started" class="btn getstarted-btn">{{ "Button.get_started" | translate}}
                </button>
            </div>
        </div>
    </form>
</div>
<div class="responsive-model-year-vin-selection" [hidden]="windowWidth>1024">
    <form [hidden]="hideSelectionSection" [formGroup]="searchForm" novalidate name="searchForm" class="m-0">
        <div class="vehicle-search-form" [ngClass]="{'mb-1':appName === 'lexus','mb-0':appName === 'toyota'}">
            <div *ngIf="appName === 'toyota'">
                <div class="p-0 suggestion-block">
                    <div class="suggestion-message">
                        <span> Select your vehicle to begin</span>
                    </div>
                </div>
            </div>
            <div *ngIf="appName === 'lexus'">
                <div class="p-0 suggestion-block">
                    <div class="suggestion-message">
                        <span> SELECT YOUR VEHICLE TO BEGIN</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Error message block -->
        <div class="vehicle-search-form form-group" [ngClass]="{'mb-1':appName === 'lexus','mb-0':appName === 'toyota'}">
            <div [hidden]="appName === 'lexus'">
                <select class="header-dropdown model-name" formControlName="model" name="model" (change)="onModelChange($event)">
                    <option class="heading" value="" disabled="" hidden="">SELECT MODEL</option>
                    <option *ngFor="let models of vehicleModel" value="{{models.model}}" [ngClass]="{'capitalize':appName === 'toyota'}">
                        {{models.model}}
                    </option>
                </select>
            </div>
            <div [hidden]="appName === 'toyota'">
                <select class="header-dropdown model-name lexus-dropdown" formControlName="model" name="model" [ngClass]="{'is-invalid-selection': (isSubmitted && showError && searchForm.get('model').errors?.required)}"
                    (change)="onModelChange($event)" required>
                    <option value="">{{ "Label.select_internal_model" | translate}}</option>
                    <option *ngFor="let models of vehicleModel" value="{{models.model}}">
                        {{models.model}}
                    </option>
                </select>
            </div>

            <div class="">
                <select [attr.disabled]="searchForm.controls['model'].value ===''?true:null" formControlName="year" name="year" class="header-dropdown"
                    [ngClass]="{'lexus-dropdown':appName === 'lexus','is-invalid-selection': (isSubmitted && showError && !searchForm.get('model').errors?.required && searchForm.get('year').errors?.required)}"
                    (change)="onYearChange($event)">
                    <option value="">SELECT YEAR</option>
                    <ng-container>
                        <option *ngFor="let years of vehicleYear" value="{{years}}">
                            {{years}}
                        </option>
                    </ng-container>
                </select>
            </div>

            <!-- Hiding VIN Search for Production Deployment -->

            <div class="or-block">
                OR
            </div>
            <div class="vin-search suggestion-block">
                <div class="suggestion-message">
                    <div class="error-message text-center hightlight-text" *ngIf="!searchForm.get('vin').errors?.required && searchForm.get('vin').errors?.pattern">
                        <span>{{"Message.invalid_VIN" | translate}}</span>
                    </div>
                </div>

                <div class="suggestion-message">
                    <div class="error-message text-center hightlight-text" *ngIf="isSubmitted && !searchForm.get('vin').errors && vinError">
                        <span>{{"Message.VIN_NOT_EXITSTS" | translate}}</span>
                    </div>
                </div>
                <div class="suggestion-message">
                    <div class="error-message text-center hightlight-text" *ngIf="isSubmitted && !searchForm.get('vin').errors && vinNotAvalibaleError">
                        <span> {{"Message.VIN_NOT_AVAILABLE" | translate}}</span>
                    </div>
                </div>
                <div class="suggestion-message">
                    <div class="error-message text-center hightlight-text" *ngIf="isSubmitted && !searchForm.get('vin').errors && vinYearNotAvalibaleError && appName === 'toyota'">
                        <span> {{"Message.VIN_TOYOTA_YEAR_NOT_AVL_ERROR" | translate}}</span>
                    </div>
                </div>
                <div class="suggestion-message">
                    <div class="error-message text-center hightlight-text" *ngIf="isSubmitted && !searchForm.get('vin').errors && vinYearNotAvalibaleError && appName === 'lexus'">
                        <span> {{"Message.VIN_LEXUS_YEAR_NOT_AVL_ERROR" | translate}}</span>
                    </div>
                </div>
                <div *ngIf="this.resultLinkSet" class="suggestion-message">
                    <div class="error-message text-center hightlight-text" *ngIf="isSubmitted && !searchForm.get('vin').errors && vinInOtherDivisionError">
                        <span *ngIf="appName === 'lexus'" style="color:#505050;display:inline-block;">
                            Sorry, This is a Toyota VIN.
                            <a target="_self" [href]="this.resultLink" style="color: #B6A171">
                                Click Here</a> to visit the Toyota site.
                        </span>
                        <span *ngIf="appName !== 'lexus'" style="color:#505050;display:inline-block;">
                            Sorry, This is a Lexus VIN.
                            <a target="_self" [href]="this.resultLink" style="color: #C00">
                                Click Here</a> to visit the Lexus site.
                        </span>
                    </div>
                </div>
            </div>
            <div class="vin-search" [ngClass]="{'invalid-vin': ((searchForm.controls['vin'].value !=='') && (vinError || vinNotAvalibaleError ||vinYearNotAvalibaleError || vinInOtherDivisionError))}">
                <mat-form-field appearance="outline" class="container-auto">
                    <input (input)="onVinKeyup($event.target.value)" matInput minLength="17" maxLength="17" class="vin-textbox" placeholder="ENTER 17 DIGIT VIN"
                        matTooltip="Add your VIN to access your vehicle specific support information." matTooltipPosition="above"
                        [disabled]="searchForm.controls['model'].value !=='' && searchForm.controls['year'].value !== ''" [ngClass]="{'invalid-vin': ( vinError || vinNotAvalibaleError ||vinYearNotAvalibaleError || vinInOtherDivisionError)}"
                        formControlName="vin" type="text" aria-live="off" [matTooltipClass]="getTooltipContent()">
                   
                </mat-form-field>
            </div>
            <div>
                <button type="button" *ngIf="!isSearchButtonSubmitted" [disabled]="commonService.disableSupportTopicPage(searchForm)" name="get-started"
                    (click)="onSearch();" class="btn getstarted-btn">{{ "Button.get_started" | translate}}
                </button>

                <button type="button" *ngIf="isSearchButtonSubmitted" [disabled]="disableSearchButton" name="get-started" class="btn getstarted-btn">{{ "Button.get_started" | translate}}
                </button>
            </div>
        </div>
    </form>
</div>